var AvailableCountries = ['US', 'CA', 'AU'];
var CountryOptions = [
    {
        label: 'United States',
        value: 'US',
    },
    {
        label: 'Canada',
        value: 'CA',
    },
];
var CountryFromCode = {
    CA: 'Canada',
    US: 'United States',
};

export { AvailableCountries, CountryFromCode, CountryOptions };
//# sourceMappingURL=countries.esm.js.map
